export const mReset = {
  compressed: false,
  requestId: "aa1389d4-aec2-4383-978e-d14275380809",
  state: "success",
  result: {
    money: 10000,
    currentBetCoin: 1,
    machineConfig: {
      machineId: "X1322",
      numBetSection: 40,
      betMoneyTable: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
      jackpotInfo: {
        configs: [
          {
            jackpotId: 1,
            jackpotType: 0,
            currentAmount: {
              type: 3,
              amount: 5,
            },
            bActive: true,
          },
          {
            jackpotId: 2,
            jackpotType: 0,
            currentAmount: {
              type: 3,
              amount: 10,
            },
            bActive: true,
          },
          {
            jackpotId: 3,
            jackpotType: 0,
            currentAmount: {
              type: 3,
              amount: 30,
            },
            bActive: true,
          },
          {
            jackpotId: 4,
            jackpotType: 0,
            currentAmount: {
              type: 3,
              amount: 100,
            },
            bActive: true,
          },
        ],
      },
      reelstrips: {
        paid_r11: [
          8, 6, 3, 1, 4, 8, 5, 0, 9, 7, 4, 1, 6, 2, 10, 3, 15, 7, 9, 2, 6, 0,
          10, 8, 4, 1, 3, 5, 15, 3, 9, 7, 15, 0, 2, 8, 6, 4, 1, 10, 5, 4, 0, 15,
          7, 2, 9, 6, 3, 8, 1, 7, 8, 9, 0, 15, 6, 2, 1, 5, 4, 3, 6, 5, 1, 9, 3,
          15, 4, 0, 8, 2, 7, 0, 2, 5, 3, 4, 1, 0, 9, 1, 7, 5, 2, 1, 8, 3, 6, 0,
          15, 4, 2, 7, 2, 0, 10, 15, 9, 5,
        ],
        paid_r12: [
          9, 1, 7, 5, 2, 1, 8, 3, 6, 0, 15, 4, 2, 7, 2, 0, 10, 15, 9, 5, 8, 6,
          3, 1, 4, 8, 5, 0, 9, 7, 4, 1, 6, 2, 10, 3, 15, 7, 9, 2, 6, 0, 10, 8,
          4, 1, 3, 5, 15, 3, 9, 7, 15, 0, 2, 8, 6, 4, 1, 10, 5, 4, 0, 15, 7, 2,
          9, 6, 3, 8, 1, 7, 8, 9, 0, 15, 6, 2, 1, 5, 4, 3, 6, 5, 1, 9, 3, 15, 4,
          0, 8, 2, 7, 0, 2, 5, 3, 4, 1, 0,
        ],
        paid_r13: [
          9, 1, 7, 5, 2, 1, 8, 3, 6, 0, 15, 4, 2, 7, 2, 0, 10, 15, 9, 5, 8, 6,
          3, 1, 4, 8, 5, 0, 9, 7, 4, 1, 6, 2, 10, 3, 15, 7, 9, 2, 6, 0, 10, 8,
          4, 1, 3, 5, 15, 3, 9, 7, 15, 0, 2, 8, 6, 4, 1, 10, 5, 4, 0, 15, 7, 2,
          9, 6, 3, 8, 1, 7, 8, 9, 0, 15, 6, 2, 1, 5, 4, 3, 6, 5, 1, 9, 3, 15, 4,
          0, 8, 2, 7, 0, 2, 5, 3, 4, 1, 0,
        ],
        paid_r21: [
          5, 8, 10, 1, 3, 0, 1, 10, 6, 15, 5, 4, 3, 7, 2, 1, 8, 9, 5, 4, 3, 2,
          6, 15, 7, 0, 9, 8, 10, 10, 1, 8, 15, 9, 5, 3, 4, 1, 7, 10, 2, 0, 12,
          6, 8, 5, 7, 2, 10, 3, 1, 0, 4, 15, 6, 9, 10, 3, 9, 4, 5, 8, 15, 7, 2,
          1, 6, 0, 2, 4, 8, 15, 0, 1, 5, 7, 9, 3, 6, 7, 0, 5, 9, 8, 15, 4, 6, 1,
          2, 8, 0, 3, 6, 9, 2, 5, 4, 15, 7, 5, 15, 7, 6, 1, 9, 4, 2, 0, 8, 3, 5,
          7, 1, 0, 2, 9, 6, 15, 4, 2, 3, 5, 8, 0, 1, 6, 4, 7, 15, 9, 1, 5, 9, 8,
          7, 6, 4, 2, 0, 3, 15, 1, 6, 4, 15, 3, 5, 7, 8, 0, 2, 9, 7, 15, 2, 8,
          1, 4, 9, 3, 0, 5, 6, 9, 2, 7, 4, 0, 8, 3, 1, 5, 6, 7, 3, 4, 0, 9, 5,
          8, 1, 6, 2, 4, 8, 5, 3, 7, 0, 2, 6, 9, 1, 5, 8, 0, 3, 4, 7, 2, 9, 6,
          3, 2, 1, 9, 7, 4, 5, 8, 0, 9, 1, 6, 5, 4, 8, 3, 7, 2, 8, 6, 5, 3, 7,
          9, 2, 0, 1, 4, 9, 6, 5, 8, 1, 0, 3, 2, 7, 9, 5, 8, 4, 2, 6, 3, 0, 7,
          1, 8, 6, 7, 9, 3, 2, 4, 1, 0, 5, 2, 7, 0, 4, 8, 9, 6, 1, 3, 5, 7, 1,
          6, 3, 9, 4, 8, 2, 0, 3, 8, 2, 5, 0, 6, 7, 4, 9, 1, 7, 6, 2, 4, 9, 0,
          3, 5, 1, 8, 6, 3, 9, 7, 2, 8, 1, 5, 4, 0, 6, 2, 9, 1, 0, 3, 7, 8, 5,
          4, 3, 6, 9, 7, 0, 5, 2, 1, 8, 2, 4, 3, 9, 5, 6, 7, 0, 8, 1, 3, 4, 5,
          7, 2, 1, 9, 6, 0, 8, 9, 3, 4, 2, 6, 5, 7, 1, 8, 3, 5, 6, 8, 9, 4, 7,
          1, 2, 0, 1, 4, 3, 8, 2, 6, 5, 0, 1, 2, 5, 4, 3, 0, 2, 3, 0, 4, 1, 5,
          4, 0, 2, 5, 3, 4, 0, 1, 2, 5, 3, 4, 0, 1, 2, 4, 3, 0, 2, 1, 4, 3, 0,
          1, 4, 2, 3, 0, 1, 3, 0, 1, 3, 0, 1, 13, 0, 15, 4, 0, 6, 2, 12, 9, 7,
          11,
        ],
        paid_r22: [
          4, 0, 6, 2, 12, 9, 7, 11, 5, 8, 10, 1, 3, 0, 1, 10, 6, 15, 5, 4, 3, 7,
          2, 1, 8, 9, 5, 4, 3, 2, 6, 15, 7, 0, 9, 8, 10, 10, 1, 8, 15, 9, 5, 3,
          4, 1, 7, 10, 2, 0, 12, 6, 8, 5, 7, 2, 10, 3, 1, 0, 4, 15, 6, 9, 10, 3,
          9, 4, 5, 8, 15, 7, 2, 1, 6, 0, 2, 4, 8, 15, 0, 1, 5, 7, 9, 3, 6, 7, 0,
          5, 9, 8, 15, 4, 6, 1, 2, 8, 0, 3, 6, 9, 2, 5, 4, 15, 7, 5, 15, 7, 6,
          1, 9, 4, 2, 0, 8, 3, 5, 7, 1, 0, 2, 9, 6, 15, 4, 2, 3, 5, 8, 0, 1, 6,
          4, 7, 15, 9, 1, 5, 9, 8, 7, 6, 4, 2, 0, 3, 15, 1, 6, 4, 15, 3, 5, 7,
          8, 0, 2, 9, 7, 15, 2, 8, 1, 4, 9, 3, 0, 5, 6, 9, 2, 7, 4, 0, 8, 3, 1,
          5, 6, 7, 3, 4, 0, 9, 5, 8, 1, 6, 2, 4, 8, 5, 3, 7, 0, 2, 6, 9, 1, 5,
          8, 0, 3, 4, 7, 2, 9, 6, 3, 2, 1, 9, 7, 4, 5, 8, 0, 9, 1, 6, 5, 4, 8,
          3, 7, 2, 8, 6, 5, 3, 7, 9, 2, 0, 1, 4, 9, 6, 5, 8, 1, 0, 3, 2, 7, 9,
          5, 8, 4, 2, 6, 3, 0, 7, 1, 8, 6, 7, 9, 3, 2, 4, 1, 0, 5, 2, 7, 0, 4,
          8, 9, 6, 1, 3, 5, 7, 1, 6, 3, 9, 4, 8, 2, 0, 3, 8, 2, 5, 0, 6, 7, 4,
          9, 1, 7, 6, 2, 4, 9, 0, 3, 5, 1, 8, 6, 3, 9, 7, 2, 8, 1, 5, 4, 0, 6,
          2, 9, 1, 0, 3, 7, 8, 5, 4, 3, 6, 9, 7, 0, 5, 2, 1, 8, 2, 4, 3, 9, 5,
          6, 7, 0, 8, 1, 3, 4, 5, 7, 2, 1, 9, 6, 0, 8, 9, 3, 4, 2, 6, 5, 7, 1,
          8, 3, 5, 6, 8, 9, 4, 7, 1, 2, 0, 1, 4, 3, 8, 2, 6, 5, 0, 1, 2, 5, 4,
          3, 0, 2, 3, 0, 4, 1, 5, 4, 0, 2, 5, 3, 4, 0, 1, 2, 5, 3, 4, 0, 1, 2,
          4, 3, 0, 2, 1, 4, 3, 0, 1, 4, 2, 3, 0, 1, 3, 0, 1, 3, 0, 1, 13, 0, 15,
        ],
        paid_r23: [
          3, 0, 1, 10, 6, 15, 5, 4, 3, 7, 2, 1, 8, 9, 5, 4, 3, 2, 6, 15, 7, 0,
          9, 8, 10, 10, 1, 8, 15, 9, 5, 3, 4, 1, 7, 10, 2, 0, 12, 6, 8, 5, 7, 2,
          10, 3, 1, 0, 4, 15, 6, 9, 10, 3, 9, 4, 5, 8, 15, 7, 2, 1, 6, 0, 2, 4,
          8, 15, 0, 1, 5, 7, 9, 3, 6, 7, 0, 5, 9, 8, 15, 4, 6, 1, 2, 8, 0, 3, 6,
          9, 2, 5, 4, 15, 7, 5, 15, 7, 6, 1, 9, 4, 2, 0, 8, 3, 5, 7, 1, 0, 2, 9,
          6, 15, 4, 2, 3, 5, 8, 0, 1, 6, 4, 7, 15, 9, 1, 5, 9, 8, 7, 6, 4, 2, 0,
          3, 15, 1, 6, 4, 15, 3, 5, 7, 8, 0, 2, 9, 7, 15, 2, 8, 1, 4, 9, 3, 0,
          5, 6, 9, 2, 7, 4, 0, 8, 3, 1, 5, 6, 7, 3, 4, 0, 9, 5, 8, 1, 6, 2, 4,
          8, 5, 3, 7, 0, 2, 6, 9, 1, 5, 8, 0, 3, 4, 7, 2, 9, 6, 3, 2, 1, 9, 7,
          4, 5, 8, 0, 9, 1, 6, 5, 4, 8, 3, 7, 2, 8, 6, 5, 3, 7, 9, 2, 0, 1, 4,
          9, 6, 5, 8, 1, 0, 3, 2, 7, 9, 5, 8, 4, 2, 6, 3, 0, 7, 1, 8, 6, 7, 9,
          3, 2, 4, 1, 0, 5, 2, 7, 0, 4, 8, 9, 6, 1, 3, 5, 7, 1, 6, 3, 9, 4, 8,
          2, 0, 3, 8, 2, 5, 0, 6, 7, 4, 9, 1, 7, 6, 2, 4, 9, 0, 3, 5, 1, 8, 6,
          3, 9, 7, 2, 8, 1, 5, 4, 0, 6, 2, 9, 1, 0, 3, 7, 8, 5, 4, 3, 6, 9, 7,
          0, 5, 2, 1, 8, 2, 4, 3, 9, 5, 6, 7, 0, 8, 1, 3, 4, 5, 7, 2, 1, 9, 6,
          0, 8, 9, 3, 4, 2, 6, 5, 7, 1, 8, 3, 5, 6, 8, 9, 4, 7, 1, 2, 0, 1, 4,
          3, 8, 2, 6, 5, 0, 1, 2, 5, 4, 3, 0, 2, 3, 0, 4, 1, 5, 4, 0, 2, 5, 3,
          4, 0, 1, 2, 5, 3, 4, 0, 1, 2, 4, 3, 0, 2, 1, 4, 3, 0, 1, 4, 2, 3, 0,
          1, 3, 0, 1, 3, 0, 1, 13, 0, 15, 4, 0, 6, 2, 12, 9, 7, 11, 5, 8, 10, 1,
        ],
        paid_r31: [
          8, 10, 1, 3, 0, 1, 10, 6, 15, 5, 4, 3, 7, 2, 1, 8, 9, 5, 4, 3, 2, 6,
          15, 7, 0, 9, 8, 10, 10, 1, 8, 15, 9, 5, 3, 4, 1, 7, 10, 2, 0, 12, 6,
          8, 5, 7, 2, 10, 3, 1, 0, 4, 15, 6, 9, 10, 3, 9, 4, 5, 8, 15, 7, 2, 1,
          6, 0, 2, 4, 8, 15, 0, 1, 5, 7, 9, 3, 6, 7, 0, 5, 9, 8, 15, 4, 6, 1, 2,
          8, 0, 3, 6, 9, 2, 5, 4, 15, 7, 5, 15, 7, 6, 1, 9, 4, 2, 0, 8, 3, 5, 7,
          1, 0, 2, 9, 6, 15, 4, 2, 3, 5, 8, 0, 1, 6, 4, 7, 15, 9, 1, 5, 9, 8, 7,
          6, 4, 2, 0, 3, 15, 1, 6, 4, 15, 3, 5, 7, 8, 0, 2, 9, 7, 15, 2, 8, 1,
          4, 9, 3, 0, 5, 6, 9, 2, 7, 4, 0, 8, 3, 1, 5, 6, 7, 3, 4, 0, 9, 5, 8,
          1, 6, 2, 4, 8, 5, 3, 7, 0, 2, 6, 9, 1, 5, 8, 0, 3, 4, 7, 2, 9, 6, 3,
          2, 1, 9, 7, 4, 5, 8, 0, 9, 1, 6, 5, 4, 8, 3, 7, 2, 8, 6, 5, 3, 7, 9,
          2, 0, 1, 4, 9, 6, 5, 8, 1, 0, 3, 2, 7, 9, 5, 8, 4, 2, 6, 3, 0, 7, 1,
          8, 6, 7, 9, 3, 2, 4, 1, 0, 5, 2, 7, 0, 4, 8, 9, 6, 1, 3, 5, 7, 1, 6,
          3, 9, 4, 8, 2, 0, 3, 8, 2, 5, 0, 6, 7, 4, 9, 1, 7, 6, 2, 4, 9, 0, 3,
          5, 1, 8, 6, 3, 9, 7, 2, 8, 1, 5, 4, 0, 6, 2, 9, 1, 0, 3, 7, 8, 5, 4,
          3, 6, 9, 7, 0, 5, 2, 1, 8, 2, 4, 3, 9, 5, 6, 7, 0, 8, 1, 3, 4, 5, 7,
          2, 1, 9, 6, 0, 8, 9, 3, 4, 2, 6, 5, 7, 1, 8, 3, 5, 6, 8, 9, 4, 7, 1,
          2, 0, 1, 4, 3, 8, 2, 6, 5, 0, 1, 2, 5, 4, 3, 0, 2, 3, 0, 4, 1, 5, 4,
          0, 2, 5, 3, 4, 0, 1, 2, 5, 3, 4, 0, 1, 2, 4, 3, 0, 2, 1, 4, 3, 0, 1,
          4, 2, 3, 0, 1, 3, 0, 1, 3, 0, 1, 13, 0, 15, 4, 0, 6, 2, 12, 9, 7, 11,
          5,
        ],
        paid_r32: [
          14, 0, 1, 3, 1, 1, 0, 3, 2, 1, 4, 3, 14, 14, 14, 14, 14, 14, 0, 5, 4,
          3, 5, 2, 1, 0, 5, 3, 4, 14, 2, 5, 4, 1, 2, 0, 3, 2, 0, 4, 5, 14, 1, 3,
          5, 4, 0, 1, 2, 3, 1, 5, 2, 14, 0, 3, 4, 5, 0, 2, 1, 3, 4, 5, 1, 14,
          14, 14, 14, 0, 2, 5, 4, 2, 1, 3, 0, 2, 3, 4, 14, 14, 14, 14, 14, 14,
          0, 1, 3, 0, 2, 1, 2, 0, 3, 2, 1, 2, 0, 3,
        ],
        paid_r33: [
          6, 2, 12, 9, 7, 11, 5, 8, 10, 1, 3, 0, 1, 10, 6, 15, 5, 4, 3, 7, 2, 1,
          8, 9, 5, 4, 3, 2, 6, 15, 7, 0, 9, 8, 10, 10, 1, 8, 15, 9, 5, 3, 4, 1,
          7, 10, 2, 0, 12, 6, 8, 5, 7, 2, 10, 3, 1, 0, 4, 15, 6, 9, 10, 3, 9, 4,
          5, 8, 15, 7, 2, 1, 6, 0, 2, 4, 8, 15, 0, 1, 5, 7, 9, 3, 6, 7, 0, 5, 9,
          8, 15, 4, 6, 1, 2, 8, 0, 3, 6, 9, 2, 5, 4, 15, 7, 5, 15, 7, 6, 1, 9,
          4, 2, 0, 8, 3, 5, 7, 1, 0, 2, 9, 6, 15, 4, 2, 3, 5, 8, 0, 1, 6, 4, 7,
          15, 9, 1, 5, 9, 8, 7, 6, 4, 2, 0, 3, 15, 1, 6, 4, 15, 3, 5, 7, 8, 0,
          2, 9, 7, 15, 2, 8, 1, 4, 9, 3, 0, 5, 6, 9, 2, 7, 4, 0, 8, 3, 1, 5, 6,
          7, 3, 4, 0, 9, 5, 8, 1, 6, 2, 4, 8, 5, 3, 7, 0, 2, 6, 9, 1, 5, 8, 0,
          3, 4, 7, 2, 9, 6, 3, 2, 1, 9, 7, 4, 5, 8, 0, 9, 1, 6, 5, 4, 8, 3, 7,
          2, 8, 6, 5, 3, 7, 9, 2, 0, 1, 4, 9, 6, 5, 8, 1, 0, 3, 2, 7, 9, 5, 8,
          4, 2, 6, 3, 0, 7, 1, 8, 6, 7, 9, 3, 2, 4, 1, 0, 5, 2, 7, 0, 4, 8, 9,
          6, 1, 3, 5, 7, 1, 6, 3, 9, 4, 8, 2, 0, 3, 8, 2, 5, 0, 6, 7, 4, 9, 1,
          7, 6, 2, 4, 9, 0, 3, 5, 1, 8, 6, 3, 9, 7, 2, 8, 1, 5, 4, 0, 6, 2, 9,
          1, 0, 3, 7, 8, 5, 4, 3, 6, 9, 7, 0, 5, 2, 1, 8, 2, 4, 3, 9, 5, 6, 7,
          0, 8, 1, 3, 4, 5, 7, 2, 1, 9, 6, 0, 8, 9, 3, 4, 2, 6, 5, 7, 1, 8, 3,
          5, 6, 8, 9, 4, 7, 1, 2, 0, 1, 4, 3, 8, 2, 6, 5, 0, 1, 2, 5, 4, 3, 0,
          2, 3, 0, 4, 1, 5, 4, 0, 2, 5, 3, 4, 0, 1, 2, 5, 3, 4, 0, 1, 2, 4, 3,
          0, 2, 1, 4, 3, 0, 1, 4, 2, 3, 0, 1, 3, 0, 1, 3, 0, 1, 13, 0, 15, 4, 0,
        ],
        paid_r41: [
          8, 10, 1, 3, 0, 1, 10, 6, 15, 5, 4, 3, 7, 2, 1, 8, 9, 5, 4, 3, 2, 6,
          15, 7, 0, 9, 8, 10, 10, 1, 8, 15, 9, 5, 3, 4, 1, 7, 10, 2, 0, 12, 6,
          8, 5, 7, 2, 10, 3, 1, 0, 4, 15, 6, 9, 10, 3, 9, 4, 5, 8, 15, 7, 2, 1,
          6, 0, 2, 4, 8, 15, 0, 1, 5, 7, 9, 3, 6, 7, 0, 5, 9, 8, 15, 4, 6, 1, 2,
          8, 0, 3, 6, 9, 2, 5, 4, 15, 7, 5, 15, 7, 6, 1, 9, 4, 2, 0, 8, 3, 5, 7,
          1, 0, 2, 9, 6, 15, 4, 2, 3, 5, 8, 0, 1, 6, 4, 7, 15, 9, 1, 5, 9, 8, 7,
          6, 4, 2, 0, 3, 15, 1, 6, 4, 15, 3, 5, 7, 8, 0, 2, 9, 7, 15, 2, 8, 1,
          4, 9, 3, 0, 5, 6, 9, 2, 7, 4, 0, 8, 3, 1, 5, 6, 7, 3, 4, 0, 9, 5, 8,
          1, 6, 2, 4, 8, 5, 3, 7, 0, 2, 6, 9, 1, 5, 8, 0, 3, 4, 7, 2, 9, 6, 3,
          2, 1, 9, 7, 4, 5, 8, 0, 9, 1, 6, 5, 4, 8, 3, 7, 2, 8, 6, 5, 3, 7, 9,
          2, 0, 1, 4, 9, 6, 5, 8, 1, 0, 3, 2, 7, 9, 5, 8, 4, 2, 6, 3, 0, 7, 1,
          8, 6, 7, 9, 3, 2, 4, 1, 0, 5, 2, 7, 0, 4, 8, 9, 6, 1, 3, 5, 7, 1, 6,
          3, 9, 4, 8, 2, 0, 3, 8, 2, 5, 0, 6, 7, 4, 9, 1, 7, 6, 2, 4, 9, 0, 3,
          5, 1, 8, 6, 3, 9, 7, 2, 8, 1, 5, 4, 0, 6, 2, 9, 1, 0, 3, 7, 8, 5, 4,
          3, 6, 9, 7, 0, 5, 2, 1, 8, 2, 4, 3, 9, 5, 6, 7, 0, 8, 1, 3, 4, 5, 7,
          2, 1, 9, 6, 0, 8, 9, 3, 4, 2, 6, 5, 7, 1, 8, 3, 5, 6, 8, 9, 4, 7, 1,
          2, 0, 1, 4, 3, 8, 2, 6, 5, 0, 1, 2, 5, 4, 3, 0, 2, 3, 0, 4, 1, 5, 4,
          0, 2, 5, 3, 4, 0, 1, 2, 5, 3, 4, 0, 1, 2, 4, 3, 0, 2, 1, 4, 3, 0, 1,
          4, 2, 3, 0, 1, 3, 0, 1, 3, 0, 1, 13, 0, 15, 4, 0, 6, 2, 12, 9, 7, 11,
          5,
        ],
        paid_r42: [
          9, 7, 11, 5, 8, 10, 1, 3, 0, 1, 10, 6, 15, 5, 4, 3, 7, 2, 1, 8, 9, 5,
          4, 3, 2, 6, 15, 7, 0, 9, 8, 10, 10, 1, 8, 15, 9, 5, 3, 4, 1, 7, 10, 2,
          0, 12, 6, 8, 5, 7, 2, 10, 3, 1, 0, 4, 15, 6, 9, 10, 3, 9, 4, 5, 8, 15,
          7, 2, 1, 6, 0, 2, 4, 8, 15, 0, 1, 5, 7, 9, 3, 6, 7, 0, 5, 9, 8, 15, 4,
          6, 1, 2, 8, 0, 3, 6, 9, 2, 5, 4, 15, 7, 5, 15, 7, 6, 1, 9, 4, 2, 0, 8,
          3, 5, 7, 1, 0, 2, 9, 6, 15, 4, 2, 3, 5, 8, 0, 1, 6, 4, 7, 15, 9, 1, 5,
          9, 8, 7, 6, 4, 2, 0, 3, 15, 1, 6, 4, 15, 3, 5, 7, 8, 0, 2, 9, 7, 15,
          2, 8, 1, 4, 9, 3, 0, 5, 6, 9, 2, 7, 4, 0, 8, 3, 1, 5, 6, 7, 3, 4, 0,
          9, 5, 8, 1, 6, 2, 4, 8, 5, 3, 7, 0, 2, 6, 9, 1, 5, 8, 0, 3, 4, 7, 2,
          9, 6, 3, 2, 1, 9, 7, 4, 5, 8, 0, 9, 1, 6, 5, 4, 8, 3, 7, 2, 8, 6, 5,
          3, 7, 9, 2, 0, 1, 4, 9, 6, 5, 8, 1, 0, 3, 2, 7, 9, 5, 8, 4, 2, 6, 3,
          0, 7, 1, 8, 6, 7, 9, 3, 2, 4, 1, 0, 5, 2, 7, 0, 4, 8, 9, 6, 1, 3, 5,
          7, 1, 6, 3, 9, 4, 8, 2, 0, 3, 8, 2, 5, 0, 6, 7, 4, 9, 1, 7, 6, 2, 4,
          9, 0, 3, 5, 1, 8, 6, 3, 9, 7, 2, 8, 1, 5, 4, 0, 6, 2, 9, 1, 0, 3, 7,
          8, 5, 4, 3, 6, 9, 7, 0, 5, 2, 1, 8, 2, 4, 3, 9, 5, 6, 7, 0, 8, 1, 3,
          4, 5, 7, 2, 1, 9, 6, 0, 8, 9, 3, 4, 2, 6, 5, 7, 1, 8, 3, 5, 6, 8, 9,
          4, 7, 1, 2, 0, 1, 4, 3, 8, 2, 6, 5, 0, 1, 2, 5, 4, 3, 0, 2, 3, 0, 4,
          1, 5, 4, 0, 2, 5, 3, 4, 0, 1, 2, 5, 3, 4, 0, 1, 2, 4, 3, 0, 2, 1, 4,
          3, 0, 1, 4, 2, 3, 0, 1, 3, 0, 1, 3, 0, 1, 13, 0, 15, 4, 0, 6, 2, 12,
        ],
        paid_r43: [
          7, 11, 5, 8, 10, 1, 3, 0, 1, 10, 6, 15, 5, 4, 3, 7, 2, 1, 8, 9, 5, 4,
          3, 2, 6, 15, 7, 0, 9, 8, 10, 10, 1, 8, 15, 9, 5, 3, 4, 1, 7, 10, 2, 0,
          12, 6, 8, 5, 7, 2, 10, 3, 1, 0, 4, 15, 6, 9, 10, 3, 9, 4, 5, 8, 15, 7,
          2, 1, 6, 0, 2, 4, 8, 15, 0, 1, 5, 7, 9, 3, 6, 7, 0, 5, 9, 8, 15, 4, 6,
          1, 2, 8, 0, 3, 6, 9, 2, 5, 4, 15, 7, 5, 15, 7, 6, 1, 9, 4, 2, 0, 8, 3,
          5, 7, 1, 0, 2, 9, 6, 15, 4, 2, 3, 5, 8, 0, 1, 6, 4, 7, 15, 9, 1, 5, 9,
          8, 7, 6, 4, 2, 0, 3, 15, 1, 6, 4, 15, 3, 5, 7, 8, 0, 2, 9, 7, 15, 2,
          8, 1, 4, 9, 3, 0, 5, 6, 9, 2, 7, 4, 0, 8, 3, 1, 5, 6, 7, 3, 4, 0, 9,
          5, 8, 1, 6, 2, 4, 8, 5, 3, 7, 0, 2, 6, 9, 1, 5, 8, 0, 3, 4, 7, 2, 9,
          6, 3, 2, 1, 9, 7, 4, 5, 8, 0, 9, 1, 6, 5, 4, 8, 3, 7, 2, 8, 6, 5, 3,
          7, 9, 2, 0, 1, 4, 9, 6, 5, 8, 1, 0, 3, 2, 7, 9, 5, 8, 4, 2, 6, 3, 0,
          7, 1, 8, 6, 7, 9, 3, 2, 4, 1, 0, 5, 2, 7, 0, 4, 8, 9, 6, 1, 3, 5, 7,
          1, 6, 3, 9, 4, 8, 2, 0, 3, 8, 2, 5, 0, 6, 7, 4, 9, 1, 7, 6, 2, 4, 9,
          0, 3, 5, 1, 8, 6, 3, 9, 7, 2, 8, 1, 5, 4, 0, 6, 2, 9, 1, 0, 3, 7, 8,
          5, 4, 3, 6, 9, 7, 0, 5, 2, 1, 8, 2, 4, 3, 9, 5, 6, 7, 0, 8, 1, 3, 4,
          5, 7, 2, 1, 9, 6, 0, 8, 9, 3, 4, 2, 6, 5, 7, 1, 8, 3, 5, 6, 8, 9, 4,
          7, 1, 2, 0, 1, 4, 3, 8, 2, 6, 5, 0, 1, 2, 5, 4, 3, 0, 2, 3, 0, 4, 1,
          5, 4, 0, 2, 5, 3, 4, 0, 1, 2, 5, 3, 4, 0, 1, 2, 4, 3, 0, 2, 1, 4, 3,
          0, 1, 4, 2, 3, 0, 1, 3, 0, 1, 3, 0, 1, 13, 0, 15, 4, 0, 6, 2, 12, 9,
        ],
        paid_r51: [
          8, 6, 3, 1, 4, 8, 5, 0, 9, 7, 4, 1, 6, 2, 10, 3, 15, 7, 9, 2, 6, 0,
          10, 8, 4, 1, 3, 5, 15, 3, 9, 7, 15, 0, 2, 8, 6, 4, 1, 10, 5, 4, 0, 15,
          7, 2, 9, 6, 3, 8, 1, 7, 8, 9, 0, 15, 6, 2, 1, 5, 4, 3, 6, 5, 1, 9, 3,
          15, 4, 0, 8, 2, 7, 0, 2, 5, 3, 4, 1, 0, 9, 1, 7, 5, 2, 1, 8, 3, 6, 0,
          15, 4, 2, 7, 2, 0, 10, 15, 9, 5,
        ],
        paid_r52: [
          9, 1, 7, 5, 2, 1, 8, 3, 6, 0, 15, 4, 2, 7, 2, 0, 10, 15, 9, 5, 8, 6,
          3, 1, 4, 8, 5, 0, 9, 7, 4, 1, 6, 2, 10, 3, 15, 7, 9, 2, 6, 0, 10, 8,
          4, 1, 3, 5, 15, 3, 9, 7, 15, 0, 2, 8, 6, 4, 1, 10, 5, 4, 0, 15, 7, 2,
          9, 6, 3, 8, 1, 7, 8, 9, 0, 15, 6, 2, 1, 5, 4, 3, 6, 5, 1, 9, 3, 15, 4,
          0, 8, 2, 7, 0, 2, 5, 3, 4, 1, 0,
        ],
        paid_r53: [
          6, 0, 15, 4, 2, 7, 2, 0, 10, 15, 9, 5, 8, 6, 3, 1, 4, 8, 5, 0, 9, 7,
          4, 1, 6, 2, 10, 3, 15, 7, 9, 2, 6, 0, 10, 8, 4, 1, 3, 5, 15, 3, 9, 7,
          15, 0, 2, 8, 6, 4, 1, 10, 5, 4, 0, 15, 7, 2, 9, 6, 3, 8, 1, 7, 8, 9,
          0, 15, 6, 2, 1, 5, 4, 3, 6, 5, 1, 9, 3, 15, 4, 0, 8, 2, 7, 0, 2, 5, 3,
          4, 1, 0, 9, 1, 7, 5, 2, 1, 8, 3,
        ],
        free_r11: [
          8, 4, 15, 9, 1, 3, 5, 15, 1, 7, 15, 4, 6, 15, 9, 10, 15, 0, 8, 15, 2,
          3, 15, 5, 9, 15, 0, 1, 15, 6, 7, 15, 8, 4, 10, 15, 3, 6, 10, 15, 0, 5,
          2, 9, 8, 4, 7, 1, 5, 2, 10, 9, 0, 6, 8, 15, 4, 3, 7, 1, 0, 9, 15, 5,
          7, 6, 4, 1, 8, 2, 3, 15, 2, 0, 6, 5, 7, 4, 1, 8, 0, 4, 3, 2, 5, 15, 1,
          3, 2, 15, 3, 0, 15, 5, 6, 15, 7, 10, 2, 15,
        ],
        free_r12: [
          9, 15, 7, 0, 1, 15, 3, 6, 15, 8, 2, 15, 10, 5, 4, 6, 15, 0, 1, 15, 5,
          2, 15, 9, 7, 15, 10, 3, 15, 4, 8, 15, 2, 6, 15, 4, 7, 15, 3, 10, 8,
          15, 9, 5, 15, 1, 0, 4, 1, 0, 6, 5, 15, 3, 7, 10, 9, 8, 2, 5, 10, 9, 1,
          8, 4, 6, 7, 2, 0, 15, 3, 8, 9, 5, 4, 1, 2, 6, 7, 0, 15, 4, 6, 0, 1, 8,
          7, 5, 3, 2, 15, 4, 2, 1, 0, 15, 3, 5, 15, 3,
        ],
        free_r13: [
          6, 15, 10, 9, 3, 15, 5, 2, 15, 10, 4, 15, 3, 9, 1, 8, 15, 0, 6, 15, 7,
          1, 8, 5, 6, 9, 0, 10, 7, 2, 15, 4, 3, 6, 9, 7, 0, 10, 15, 8, 2, 5, 1,
          2, 7, 8, 5, 15, 1, 4, 6, 3, 9, 0, 15, 2, 8, 3, 7, 0, 4, 5, 1, 6, 3, 0,
          5, 4, 15, 1, 2, 8, 3, 15, 4, 1, 15, 6, 4, 7, 15, 5, 0, 15, 10, 3, 15,
          9, 2, 15, 4, 8, 15, 7, 5, 15, 2, 1, 15, 0,
        ],
        free_r21: [
          5, 8, 15, 4, 7, 15, 3, 11, 15, 13, 1, 15, 6, 0, 15, 2, 5, 15, 9, 10,
          12, 15, 6, 9, 15, 8, 3, 15, 11, 10, 15, 0, 2, 15, 4, 1, 15, 5, 7, 15,
          3, 4, 10, 15, 0, 6, 15, 9, 5, 15, 2, 7, 15, 8, 1, 15, 7, 10, 15, 6, 4,
          15, 9, 2, 15, 0, 3, 8, 1, 15, 5, 8, 15, 0, 5, 15, 9, 7, 15, 4, 2, 15,
          10, 1, 6, 3, 15, 6, 0, 9, 5, 15, 3, 8, 15, 7, 4, 2, 1, 4, 5, 15, 2, 7,
          8, 1, 0, 9, 6, 3, 1, 2, 0, 5, 7, 8, 4, 9, 3, 6, 15, 9, 4, 0, 1, 3, 8,
          15, 7, 6, 5, 2, 7, 4, 3, 8, 2, 0, 15, 1, 5, 6, 9, 3, 15, 4, 0, 1, 7,
          5, 8, 9, 2, 6, 4, 15, 5, 1, 9, 3, 7, 2, 6, 8, 0, 3, 6, 4, 1, 2, 9, 5,
          15, 7, 8, 5, 6, 8, 3, 9, 1, 0, 7, 4, 15, 2, 0, 6, 15, 4, 1, 2, 3, 7,
          5, 8, 0, 3, 2, 15, 7, 5, 1, 4, 6, 5, 4, 1, 0, 3, 15, 2, 4, 0, 3, 15,
          5, 1, 2, 4, 5, 15, 3, 1, 0, 15, 2, 0, 15, 1, 0, 15, 7, 8, 15, 3, 13,
          2, 15, 9, 12, 15, 10, 1, 15, 0, 6, 15, 11, 4,
        ],
        free_r22: [
          4, 2, 15, 8, 9, 7, 15, 3, 10, 15, 13, 12, 15, 5, 1, 15, 4, 9, 15, 11,
          8, 15, 0, 2, 15, 6, 8, 0, 15, 7, 2, 15, 6, 1, 15, 5, 11, 15, 4, 3, 15,
          10, 9, 15, 3, 4, 15, 0, 1, 15, 9, 8, 15, 6, 10, 7, 5, 15, 2, 7, 15, 8,
          3, 15, 6, 10, 15, 2, 9, 5, 15, 4, 1, 0, 15, 6, 5, 15, 8, 3, 15, 1, 10,
          15, 9, 7, 15, 2, 4, 0, 15, 4, 2, 15, 7, 3, 15, 5, 6, 1, 0, 9, 8, 0, 1,
          15, 5, 8, 3, 6, 9, 2, 4, 7, 9, 5, 2, 1, 3, 0, 7, 8, 15, 6, 4, 1, 0, 4,
          6, 15, 5, 2, 7, 3, 9, 8, 1, 2, 6, 15, 8, 7, 3, 4, 5, 0, 1, 4, 8, 3, 2,
          9, 6, 5, 7, 0, 15, 8, 0, 6, 1, 2, 7, 4, 9, 5, 3, 15, 6, 0, 5, 9, 8, 7,
          1, 15, 2, 4, 1, 3, 9, 15, 0, 6, 7, 4, 8, 5, 2, 8, 3, 4, 6, 2, 15, 5,
          0, 7, 9, 1, 6, 5, 4, 15, 1, 3, 7, 2, 0, 1, 3, 4, 5, 0, 15, 2, 1, 15,
          3, 0, 4, 5, 15, 2, 1, 3, 0, 15, 2, 1, 3, 4, 5, 15, 0, 11, 15, 6, 7,
          15, 12, 13, 15, 1, 3, 15, 5, 0, 10, 15,
        ],
        free_r23: [
          3, 7, 15, 10, 4, 15, 13, 8, 15, 6, 2, 15, 12, 0, 13, 15, 11, 10, 15,
          1, 4, 15, 9, 8, 15, 6, 5, 15, 3, 7, 15, 2, 11, 15, 8, 10, 15, 6, 4,
          15, 9, 0, 3, 15, 1, 5, 8, 6, 15, 5, 7, 15, 10, 0, 15, 2, 9, 15, 3, 4,
          1, 0, 15, 1, 7, 15, 4, 5, 15, 9, 8, 15, 2, 3, 15, 10, 6, 3, 9, 15, 8,
          7, 15, 6, 0, 15, 1, 5, 15, 10, 4, 15, 2, 9, 15, 3, 8, 15, 0, 6, 4, 15,
          5, 7, 1, 2, 0, 15, 3, 8, 1, 7, 5, 9, 6, 4, 2, 9, 0, 1, 6, 3, 2, 15, 8,
          7, 5, 4, 6, 9, 3, 15, 0, 5, 8, 2, 4, 1, 7, 9, 3, 7, 4, 6, 8, 2, 15, 0,
          1, 5, 15, 2, 0, 3, 5, 1, 8, 6, 7, 4, 9, 6, 15, 7, 9, 3, 4, 2, 1, 0, 5,
          8, 9, 3, 0, 4, 2, 8, 15, 6, 7, 5, 1, 6, 4, 5, 2, 7, 8, 3, 9, 0, 15, 5,
          8, 1, 4, 0, 2, 3, 7, 15, 6, 3, 5, 4, 6, 0, 2, 15, 7, 1, 3, 0, 1, 7, 2,
          15, 4, 5, 2, 3, 15, 0, 1, 5, 4, 3, 15, 5, 2, 0, 4, 1, 2, 15, 0, 1, 15,
          9, 15, 1, 5, 15, 1, 12, 15, 0, 11, 15,
        ],
        free_r31: [
          8, 0, 15, 13, 2, 0, 15, 9, 4, 15, 3, 5, 15, 1, 12, 15, 7, 6, 15, 11,
          0, 15, 10, 12, 15, 3, 4, 15, 10, 6, 0, 15, 2, 5, 15, 1, 11, 15, 9, 7,
          15, 8, 13, 3, 1, 15, 6, 11, 15, 10, 9, 15, 5, 8, 15, 4, 7, 15, 2, 0,
          15, 4, 10, 9, 15, 3, 2, 15, 1, 7, 15, 5, 8, 15, 6, 9, 15, 10, 6, 8, 7,
          15, 0, 4, 15, 1, 3, 15, 2, 5, 15, 7, 3, 15, 2, 5, 15, 6, 0, 15, 10, 9,
          1, 4, 15, 8, 9, 15, 4, 3, 6, 15, 2, 1, 15, 7, 0, 5, 2, 8, 3, 0, 9, 4,
          5, 6, 15, 1, 7, 6, 4, 0, 5, 9, 3, 1, 8, 2, 15, 1, 4, 0, 2, 7, 8, 5, 6,
          3, 9, 15, 6, 5, 3, 7, 9, 4, 0, 1, 8, 2, 15, 9, 2, 0, 15, 3, 7, 1, 5,
          8, 4, 6, 15, 3, 1, 2, 0, 5, 8, 7, 9, 15, 0, 4, 6, 3, 5, 2, 7, 8, 1, 5,
          4, 1, 0, 8, 3, 6, 9, 2, 15, 7, 9, 4, 3, 1, 8, 7, 15, 5, 6, 2, 0, 5, 4,
          6, 7, 3, 8, 1, 15, 0, 4, 5, 6, 3, 7, 2, 15, 1, 3, 15, 1, 5, 4, 0, 2,
          4, 3, 5, 2, 15, 1, 0, 2, 4, 15, 1, 0, 15,
        ],
        free_r32: [14],
        free_r33: [
          6, 15, 11, 5, 15, 12, 13, 15, 8, 10, 15, 0, 13, 15, 6, 1, 15, 9, 5,
          15, 12, 4, 15, 3, 2, 11, 7, 15, 1, 7, 15, 11, 10, 15, 2, 0, 15, 4, 6,
          15, 9, 3, 5, 15, 8, 1, 15, 0, 9, 15, 4, 10, 15, 7, 3, 6, 5, 15, 8, 2,
          15, 6, 1, 15, 3, 2, 15, 9, 0, 8, 5, 15, 4, 7, 15, 10, 5, 6, 4, 15, 8,
          9, 15, 7, 10, 15, 3, 1, 15, 2, 0, 15, 8, 7, 15, 0, 9, 15, 6, 5, 3, 15,
          4, 2, 15, 1, 9, 8, 6, 4, 7, 15, 0, 5, 1, 3, 2, 1, 0, 15, 2, 3, 7, 5,
          6, 4, 8, 9, 2, 3, 0, 6, 7, 15, 9, 4, 1, 5, 8, 15, 9, 4, 2, 5, 3, 0, 1,
          6, 7, 1, 2, 4, 15, 3, 0, 7, 5, 8, 9, 6, 1, 2, 8, 15, 5, 0, 3, 9, 4, 7,
          0, 8, 6, 2, 9, 4, 5, 1, 15, 3, 7, 15, 9, 5, 8, 2, 3, 7, 1, 0, 4, 6, 7,
          1, 0, 4, 8, 15, 5, 2, 3, 15, 0, 4, 7, 1, 2, 5, 8, 6, 3, 2, 15, 4, 6,
          0, 1, 5, 3, 0, 4, 2, 15, 5, 6, 1, 3, 5, 1, 15, 4, 0, 2, 1, 15, 3, 0,
          15, 3, 0, 8, 1, 15, 10, 2, 15, 7, 4, 15, 9,
        ],
        free_r41: [
          8, 15, 11, 4, 15, 13, 2, 15, 10, 1, 0, 15, 3, 6, 15, 12, 5, 3, 10, 15,
          11, 1, 15, 12, 7, 15, 2, 6, 15, 8, 5, 15, 4, 0, 15, 9, 13, 15, 3, 1,
          15, 10, 2, 15, 0, 9, 8, 15, 6, 5, 15, 4, 7, 15, 11, 4, 15, 8, 5, 15,
          1, 10, 15, 2, 7, 15, 9, 0, 3, 6, 15, 8, 7, 15, 10, 0, 15, 4, 2, 9, 5,
          15, 3, 1, 15, 6, 7, 15, 0, 9, 15, 1, 10, 15, 4, 2, 15, 5, 8, 15, 4, 5,
          15, 2, 6, 15, 0, 3, 1, 9, 8, 15, 7, 8, 2, 5, 7, 1, 9, 4, 0, 15, 3, 6,
          7, 2, 8, 9, 15, 0, 6, 4, 3, 1, 5, 15, 6, 4, 7, 5, 3, 9, 1, 8, 0, 2,
          15, 7, 6, 4, 9, 5, 0, 8, 1, 3, 2, 5, 15, 8, 9, 3, 6, 4, 7, 0, 1, 7, 0,
          6, 9, 4, 5, 8, 3, 2, 15, 5, 1, 4, 8, 2, 3, 6, 0, 7, 9, 15, 4, 0, 9, 5,
          2, 8, 1, 15, 7, 6, 3, 0, 6, 1, 2, 15, 5, 4, 7, 3, 8, 7, 6, 1, 5, 0, 2,
          4, 3, 15, 0, 5, 1, 15, 2, 6, 3, 4, 0, 2, 3, 15, 5, 1, 4, 5, 0, 2, 15,
          3, 1, 0, 4, 15, 3, 1, 2, 15, 1, 9, 15, 7,
        ],
        free_r42: [
          9, 3, 12, 15, 8, 5, 15, 3, 13, 15, 0, 11, 15, 4, 7, 15, 1, 10, 6, 15,
          2, 12, 15, 5, 7, 15, 1, 2, 15, 0, 13, 11, 10, 15, 6, 8, 15, 9, 3, 15,
          4, 8, 7, 0, 15, 5, 4, 15, 6, 11, 15, 2, 9, 15, 10, 3, 15, 1, 8, 15,
          10, 9, 15, 4, 0, 15, 5, 2, 15, 1, 3, 7, 6, 15, 2, 4, 15, 0, 9, 3, 15,
          5, 1, 15, 10, 8, 15, 6, 7, 15, 4, 9, 15, 1, 8, 15, 2, 5, 15, 0, 3, 10,
          15, 6, 3, 15, 6, 0, 15, 4, 7, 15, 8, 2, 15, 1, 5, 9, 0, 5, 2, 6, 7, 1,
          4, 15, 3, 9, 8, 3, 9, 0, 8, 4, 7, 5, 15, 6, 1, 2, 6, 4, 2, 9, 5, 0, 3,
          1, 8, 15, 7, 5, 15, 3, 0, 1, 6, 8, 9, 4, 2, 0, 6, 7, 4, 1, 9, 8, 3,
          15, 2, 5, 15, 3, 6, 5, 2, 4, 9, 1, 0, 8, 7, 5, 1, 2, 9, 4, 15, 0, 6,
          8, 3, 2, 7, 8, 0, 5, 1, 4, 9, 15, 6, 3, 4, 1, 15, 8, 0, 7, 5, 6, 2, 1,
          15, 3, 5, 2, 4, 7, 0, 6, 4, 5, 7, 0, 1, 2, 15, 3, 2, 15, 1, 4, 7, 0,
          5, 4, 1, 7, 2, 0, 15, 3, 5, 15, 1, 0, 3, 15,
        ],
        free_r43: [
          6, 15, 12, 11, 15, 8, 0, 15, 3, 2, 1, 0, 15, 11, 8, 15, 10, 13, 15, 9,
          6, 15, 5, 7, 15, 4, 5, 15, 2, 7, 1, 15, 3, 8, 15, 0, 6, 15, 4, 10, 15,
          9, 6, 15, 10, 3, 8, 15, 2, 5, 15, 4, 0, 15, 1, 9, 15, 7, 8, 15, 9, 10,
          15, 7, 0, 3, 15, 5, 6, 15, 1, 2, 15, 4, 7, 15, 0, 6, 15, 5, 9, 4, 10,
          8, 3, 15, 2, 1, 8, 6, 2, 5, 15, 1, 4, 7, 3, 9, 0, 8, 7, 6, 1, 0, 15,
          5, 2, 4, 3, 9, 2, 6, 9, 8, 4, 7, 5, 15, 0, 3, 1, 7, 4, 0, 8, 15, 5, 3,
          9, 1, 6, 2, 8, 0, 1, 7, 3, 9, 2, 15, 6, 4, 5, 1, 3, 6, 8, 2, 0, 4, 9,
          5, 15, 7, 8, 9, 0, 5, 15, 7, 2, 3, 4, 1, 6, 15, 1, 3, 6, 2, 4, 9, 5,
          7, 8, 0, 15, 7, 3, 5, 8, 1, 0, 2, 4, 6, 3, 4, 5, 15, 2, 7, 6, 0, 1, 2,
          4, 3, 15, 5, 1, 2, 15, 1, 5, 0, 4, 3, 1, 15, 5, 2, 3, 0, 4, 15, 0, 1,
          15, 0, 12, 15, 6, 9, 11, 3, 15, 1, 2, 15, 0, 5, 15, 8, 4, 15, 7, 10,
          13, 15, 1, 2, 15, 4, 5, 15, 3, 7, 15, 9,
        ],
        free_r51: [
          8, 15, 10, 5, 6, 7, 15, 2, 9, 15, 3, 0, 1, 15, 4, 8, 15, 0, 2, 15, 3,
          7, 15, 9, 5, 15, 10, 6, 7, 15, 8, 2, 15, 6, 0, 15, 3, 10, 15, 5, 1, 4,
          9, 15, 7, 9, 15, 0, 5, 15, 6, 1, 8, 4, 2, 10, 3, 8, 0, 4, 5, 10, 2, 3,
          6, 7, 15, 1, 9, 3, 15, 6, 7, 5, 8, 4, 0, 1, 9, 2, 15, 6, 2, 5, 7, 1,
          8, 4, 3, 0, 1, 4, 15, 2, 5, 3, 0, 1, 15, 4,
        ],
        free_r52: [
          9, 15, 7, 1, 6, 15, 8, 0, 15, 7, 3, 15, 2, 1, 15, 4, 10, 15, 5, 9, 15,
          4, 10, 8, 2, 9, 7, 3, 0, 5, 1, 6, 15, 2, 10, 5, 6, 15, 1, 9, 4, 7, 0,
          3, 8, 5, 3, 9, 1, 2, 15, 6, 8, 4, 0, 7, 6, 15, 5, 3, 8, 0, 7, 4, 2, 1,
          15, 3, 2, 0, 5, 1, 4, 15, 4, 2, 15, 8, 9, 7, 6, 15, 1, 5, 15, 0, 3,
          15, 10, 4, 15, 0, 10, 5, 6, 15, 3, 8, 15, 2,
        ],
        free_r53: [
          6, 15, 8, 3, 15, 10, 0, 15, 6, 2, 1, 4, 15, 0, 10, 15, 8, 5, 15, 7, 9,
          15, 3, 4, 15, 1, 8, 5, 7, 3, 15, 2, 0, 10, 6, 1, 2, 4, 3, 10, 5, 6, 7,
          9, 0, 15, 8, 5, 15, 3, 8, 9, 1, 7, 4, 6, 2, 0, 6, 5, 0, 15, 2, 4, 7,
          1, 3, 8, 9, 2, 15, 1, 0, 4, 3, 5, 15, 9, 5, 15, 4, 1, 15, 3, 2, 10, 7,
          15, 6, 0, 5, 8, 15, 2, 9, 15, 7, 4, 15, 1,
        ],
        freeBuy_r11: [
          8, 3, 15, 2, 7, 15, 9, 10, 15, 6, 0, 15, 7, 9, 15, 3, 4, 2, 15, 6, 10,
          15, 5, 8, 15, 1, 10, 15, 4, 8, 15, 3, 2, 7, 1, 15, 5, 6, 15, 0, 9, 15,
          10, 7, 9, 0, 5, 4, 6, 1, 8, 2, 3, 15, 9, 1, 7, 4, 2, 15, 10, 5, 8, 3,
          6, 0, 1, 15, 6, 2, 10, 9, 3, 5, 4, 0, 7, 8, 5, 7, 3, 1, 6, 15, 4, 2,
          0, 4, 3, 0, 15, 5, 1, 2, 15, 4, 0, 1, 5, 15,
        ],
        freeBuy_r12: [
          9, 8, 15, 7, 2, 10, 1, 15, 10, 5, 15, 8, 7, 15, 6, 9, 15, 3, 2, 15, 0,
          4, 15, 7, 2, 15, 10, 0, 15, 1, 6, 4, 3, 8, 5, 15, 9, 10, 5, 9, 3, 15,
          4, 2, 0, 6, 7, 1, 8, 7, 1, 6, 0, 5, 4, 3, 9, 15, 2, 10, 1, 9, 7, 6, 8,
          0, 15, 4, 2, 3, 5, 10, 3, 15, 0, 2, 1, 8, 4, 7, 6, 4, 5, 15, 0, 3, 2,
          1, 5, 15, 15, 0, 5, 15, 4, 1, 15, 3, 6, 15,
        ],
        freeBuy_r13: [
          6, 5, 15, 7, 3, 15, 1, 0, 15, 9, 6, 15, 7, 2, 15, 0, 3, 10, 5, 15, 8,
          1, 15, 4, 0, 7, 8, 15, 2, 3, 15, 4, 5, 15, 9, 6, 15, 10, 1, 15, 4, 9,
          7, 5, 0, 3, 15, 2, 6, 10, 8, 1, 5, 3, 1, 7, 15, 4, 6, 10, 9, 0, 8, 2,
          15, 9, 5, 10, 1, 8, 3, 2, 4, 7, 0, 6, 3, 7, 4, 6, 0, 1, 15, 5, 2, 3,
          5, 1, 4, 15, 0, 2, 15, 9, 10, 15, 2, 4, 15, 8,
        ],
        freeBuy_r21: [
          5, 10, 15, 11, 3, 15, 0, 12, 15, 6, 4, 15, 2, 7, 15, 13, 8, 1, 15, 9,
          0, 15, 1, 13, 15, 4, 6, 15, 8, 10, 5, 2, 15, 7, 11, 15, 12, 3, 15, 9,
          4, 15, 12, 5, 15, 10, 8, 15, 2, 3, 7, 11, 15, 6, 0, 15, 13, 1, 15, 3,
          8, 15, 7, 2, 15, 10, 4, 15, 5, 0, 15, 6, 1, 12, 15, 9, 11, 15, 5, 3,
          15, 7, 1, 15, 10, 8, 15, 9, 6, 0, 15, 4, 2, 15, 5, 2, 15, 3, 7, 15, 1,
          0, 15, 6, 8, 15, 4, 9, 15, 8, 0, 15, 2, 9, 6, 3, 1, 5, 4, 7, 15, 4, 6,
          5, 7, 0, 9, 8, 3, 2, 1, 5, 8, 0, 6, 9, 2, 15, 1, 7, 3, 4, 9, 0, 5, 6,
          2, 7, 1, 8, 15, 4, 3, 0, 8, 5, 7, 2, 9, 6, 4, 15, 3, 1, 0, 5, 7, 2, 6,
          4, 1, 15, 9, 8, 15, 4, 2, 7, 1, 9, 3, 0, 6, 5, 4, 7, 3, 2, 0, 8, 6, 9,
          15, 1, 8, 7, 3, 6, 5, 9, 0, 2, 15, 4, 9, 0, 2, 6, 3, 1, 8, 4, 5, 7, 3,
          5, 2, 15, 1, 4, 6, 0, 5, 3, 4, 15, 1, 2, 5, 3, 15, 1, 0, 4, 2, 1, 15,
          5, 3, 4, 15, 1, 0, 5, 2, 0, 15, 3, 0, 15,
        ],
        freeBuy_r22: [
          3, 0, 5, 15, 9, 1, 15, 10, 4, 15, 8, 13, 15, 2, 12, 15, 7, 11, 15, 0,
          6, 15, 1, 9, 15, 11, 2, 15, 10, 5, 15, 12, 8, 15, 7, 6, 15, 13, 3, 0,
          15, 4, 8, 15, 10, 13, 15, 2, 12, 15, 6, 7, 15, 3, 5, 0, 1, 15, 9, 4,
          15, 11, 7, 15, 12, 8, 15, 11, 9, 15, 1, 6, 15, 4, 5, 10, 15, 2, 0, 15,
          3, 4, 7, 15, 2, 3, 15, 6, 10, 15, 5, 0, 15, 1, 9, 8, 6, 15, 7, 9, 15,
          5, 0, 15, 4, 2, 15, 3, 8, 15, 1, 5, 0, 15, 6, 9, 15, 4, 2, 15, 7, 3,
          1, 8, 15, 9, 2, 0, 5, 3, 4, 1, 7, 6, 0, 15, 8, 7, 9, 3, 6, 2, 5, 4, 1,
          3, 8, 9, 15, 5, 0, 6, 4, 2, 1, 7, 9, 4, 15, 1, 2, 5, 8, 0, 3, 7, 6, 1,
          9, 4, 15, 3, 2, 6, 8, 5, 0, 2, 4, 1, 7, 6, 3, 15, 8, 5, 9, 0, 2, 1, 8,
          4, 0, 7, 6, 15, 5, 3, 9, 0, 15, 3, 1, 4, 6, 5, 8, 2, 7, 0, 6, 3, 15,
          8, 1, 2, 7, 5, 9, 4, 3, 2, 0, 6, 7, 4, 1, 5, 15, 4, 5, 2, 3, 1, 0, 3,
          4, 5, 2, 1, 15, 4, 1, 2, 0, 15, 5, 3, 0, 15,
        ],
        freeBuy_r23: [
          4, 15, 3, 1, 15, 7, 6, 15, 0, 8, 15, 13, 5, 15, 10, 12, 15, 13, 1, 15,
          8, 9, 15, 3, 4, 15, 5, 7, 2, 15, 11, 0, 15, 6, 8, 15, 12, 11, 15, 2,
          0, 15, 4, 3, 15, 13, 1, 7, 6, 15, 9, 5, 15, 10, 9, 15, 7, 8, 15, 2, 5,
          6, 10, 15, 4, 3, 15, 0, 1, 15, 11, 12, 15, 7, 6, 15, 1, 5, 15, 0, 2,
          4, 8, 15, 9, 3, 15, 10, 8, 15, 9, 0, 15, 1, 2, 15, 7, 4, 5, 6, 15, 1,
          9, 15, 0, 8, 6, 15, 4, 5, 15, 2, 7, 3, 9, 8, 6, 2, 0, 1, 7, 4, 5, 15,
          0, 5, 1, 15, 2, 4, 7, 3, 8, 6, 9, 2, 15, 7, 8, 6, 3, 0, 1, 5, 4, 15,
          3, 8, 5, 7, 1, 6, 2, 0, 4, 9, 0, 7, 8, 2, 1, 5, 6, 3, 4, 15, 9, 6, 3,
          4, 15, 0, 8, 7, 5, 9, 1, 2, 5, 15, 9, 8, 6, 1, 3, 0, 7, 4, 2, 7, 4, 9,
          3, 1, 2, 8, 15, 5, 0, 6, 9, 3, 4, 5, 2, 15, 6, 0, 7, 1, 4, 0, 3, 15,
          5, 2, 6, 15, 0, 2, 3, 1, 4, 5, 1, 4, 3, 5, 0, 15, 2, 0, 3, 5, 4, 2, 1,
          15, 0, 3, 1, 15, 3, 10, 15, 9, 11, 15, 2, 12,
        ],
        freeBuy_r31: [
          8, 15, 3, 10, 15, 1, 6, 15, 4, 9, 15, 3, 7, 15, 5, 1, 15, 2, 8, 15,
          10, 13, 15, 0, 11, 12, 15, 13, 0, 1, 15, 7, 2, 15, 8, 3, 15, 5, 9, 15,
          6, 10, 15, 11, 4, 12, 15, 5, 8, 15, 10, 11, 15, 2, 4, 15, 6, 0, 15, 3,
          1, 15, 9, 7, 15, 3, 8, 15, 9, 10, 7, 12, 15, 1, 6, 15, 5, 0, 15, 2, 4,
          15, 9, 3, 15, 6, 0, 15, 5, 4, 1, 15, 8, 7, 15, 2, 9, 15, 6, 4, 15, 8,
          5, 1, 0, 2, 15, 3, 4, 7, 5, 8, 1, 9, 2, 0, 6, 3, 9, 6, 3, 0, 8, 7, 5,
          1, 15, 4, 2, 6, 5, 15, 2, 1, 0, 4, 3, 8, 9, 7, 3, 1, 9, 5, 8, 4, 15,
          7, 0, 2, 6, 15, 9, 3, 4, 7, 6, 2, 1, 8, 5, 0, 2, 3, 7, 9, 8, 15, 1, 4,
          6, 5, 3, 2, 5, 4, 1, 6, 8, 15, 7, 0, 9, 8, 7, 2, 15, 3, 5, 4, 1, 6, 3,
          7, 0, 15, 6, 4, 5, 9, 2, 1, 0, 2, 1, 4, 3, 7, 5, 6, 15, 4, 1, 5, 15,
          2, 3, 0, 4, 2, 15, 1, 0, 5, 3, 1, 2, 4, 15, 5, 3, 0, 15, 2, 0, 4, 15,
          0, 13, 11, 15, 12, 0, 15, 5, 0, 15, 6, 7, 9,
        ],
        freeBuy_r32: [14],
        freeBuy_r33: [
          6, 12, 15, 10, 8, 15, 11, 13, 15, 7, 0, 2, 15, 4, 9, 15, 1, 0, 15, 13,
          6, 3, 15, 9, 10, 15, 8, 2, 15, 12, 5, 15, 7, 11, 15, 1, 4, 15, 7, 1,
          15, 10, 8, 11, 15, 6, 3, 15, 12, 13, 15, 2, 5, 15, 0, 9, 15, 3, 6, 15,
          2, 12, 8, 15, 4, 7, 15, 1, 11, 15, 9, 10, 15, 0, 5, 15, 4, 9, 7, 10,
          15, 1, 5, 15, 3, 6, 15, 8, 2, 0, 15, 3, 0, 15, 4, 5, 15, 9, 1, 15, 2,
          6, 15, 7, 8, 1, 5, 2, 3, 6, 7, 0, 4, 8, 15, 9, 8, 7, 4, 0, 5, 1, 15,
          9, 2, 3, 6, 9, 8, 0, 2, 7, 4, 5, 1, 15, 6, 3, 7, 15, 9, 4, 5, 2, 1, 8,
          0, 6, 3, 4, 5, 2, 15, 9, 0, 7, 8, 6, 1, 9, 8, 5, 6, 1, 3, 7, 2, 4, 15,
          0, 2, 8, 6, 3, 5, 15, 7, 1, 9, 4, 15, 2, 9, 3, 1, 8, 4, 5, 6, 7, 0, 2,
          15, 9, 8, 4, 0, 1, 7, 5, 6, 3, 2, 15, 0, 1, 4, 3, 6, 7, 5, 6, 15, 2,
          3, 1, 0, 4, 15, 2, 0, 5, 1, 3, 4, 0, 15, 5, 2, 3, 1, 0, 4, 2, 15, 1,
          5, 15, 0, 4, 3, 5, 15, 3, 0, 4, 15, 3, 5, 15,
        ],
        freeBuy_r41: [
          8, 15, 1, 3, 15, 12, 6, 15, 2, 7, 5, 15, 3, 0, 15, 6, 8, 15, 2, 12,
          15, 13, 4, 15, 1, 10, 15, 7, 9, 15, 11, 7, 15, 6, 10, 1, 15, 9, 4, 15,
          2, 0, 15, 12, 3, 15, 13, 8, 15, 5, 3, 8, 15, 10, 2, 15, 7, 11, 15, 6,
          12, 15, 5, 9, 15, 4, 1, 15, 0, 7, 15, 10, 2, 15, 1, 4, 15, 9, 8, 5, 6,
          15, 0, 11, 15, 3, 7, 8, 15, 2, 3, 15, 1, 9, 15, 0, 4, 15, 5, 6, 15, 2,
          4, 0, 7, 6, 1, 9, 15, 3, 8, 0, 7, 15, 4, 8, 9, 3, 2, 6, 5, 1, 8, 3, 9,
          6, 4, 7, 2, 15, 1, 5, 0, 1, 9, 3, 6, 7, 0, 8, 15, 4, 2, 7, 6, 3, 4, 5,
          8, 0, 9, 15, 2, 1, 9, 8, 3, 2, 5, 0, 4, 7, 15, 6, 0, 9, 3, 2, 6, 7,
          15, 1, 5, 4, 8, 5, 1, 7, 6, 3, 0, 15, 2, 8, 4, 9, 5, 0, 1, 15, 4, 7,
          6, 8, 3, 9, 2, 15, 5, 6, 4, 1, 0, 2, 7, 3, 1, 4, 3, 15, 0, 5, 6, 2, 3,
          5, 4, 0, 15, 2, 1, 4, 5, 15, 2, 3, 1, 0, 15, 2, 4, 0, 5, 3, 1, 0, 15,
          1, 5, 15, 10, 5, 13, 15, 5, 11, 9, 15, 0, 4,
        ],
        freeBuy_r42: [
          9, 15, 7, 0, 15, 11, 6, 15, 4, 12, 15, 5, 1, 15, 7, 13, 8, 10, 15, 9,
          2, 3, 13, 15, 11, 4, 15, 12, 5, 15, 6, 1, 15, 7, 0, 15, 8, 10, 15, 3,
          9, 15, 2, 6, 15, 7, 11, 15, 12, 8, 15, 4, 1, 15, 2, 10, 5, 0, 15, 3,
          9, 15, 1, 3, 15, 9, 10, 15, 0, 7, 15, 8, 6, 4, 2, 15, 5, 8, 15, 1, 9,
          15, 0, 3, 6, 7, 15, 4, 2, 15, 0, 1, 15, 8, 7, 9, 15, 4, 6, 3, 5, 7, 1,
          9, 5, 15, 6, 0, 4, 2, 3, 8, 1, 9, 2, 8, 7, 6, 0, 15, 5, 4, 3, 9, 5,
          15, 7, 2, 8, 6, 0, 1, 8, 6, 9, 0, 4, 15, 2, 3, 5, 7, 1, 9, 0, 1, 15,
          8, 4, 2, 5, 7, 6, 3, 7, 1, 4, 2, 3, 6, 15, 8, 5, 0, 9, 4, 7, 6, 1, 2,
          5, 8, 15, 0, 3, 9, 15, 0, 3, 6, 8, 7, 2, 5, 1, 4, 7, 5, 15, 1, 9, 6,
          2, 0, 3, 15, 4, 5, 6, 2, 1, 3, 0, 5, 2, 4, 1, 3, 15, 0, 3, 4, 15, 1,
          2, 5, 3, 4, 5, 0, 1, 15, 3, 0, 15, 5, 4, 2, 15, 4, 0, 2, 15, 5, 2, 15,
          10, 13, 15, 6, 0, 1, 15, 12, 4, 15, 11, 3, 15, 8,
        ],
        freeBuy_r43: [
          6, 12, 15, 3, 8, 2, 10, 15, 0, 11, 15, 7, 5, 15, 9, 4, 15, 13, 1, 15,
          4, 11, 15, 6, 7, 15, 1, 12, 15, 8, 3, 5, 15, 10, 9, 15, 0, 2, 15, 13,
          12, 15, 7, 0, 10, 15, 8, 13, 15, 9, 4, 15, 3, 11, 15, 1, 5, 6, 2, 15,
          10, 12, 15, 1, 3, 15, 5, 11, 15, 8, 0, 15, 9, 6, 15, 2, 4, 15, 7, 5,
          15, 2, 10, 3, 0, 15, 9, 7, 15, 8, 4, 15, 1, 6, 15, 8, 3, 4, 15, 0, 2,
          15, 7, 5, 15, 1, 6, 15, 9, 2, 15, 1, 7, 15, 9, 0, 3, 4, 8, 5, 15, 9,
          7, 3, 0, 4, 2, 6, 1, 5, 8, 15, 3, 2, 1, 4, 0, 5, 6, 9, 7, 8, 6, 0, 2,
          3, 5, 7, 4, 15, 9, 1, 3, 15, 6, 0, 7, 8, 1, 9, 5, 2, 4, 7, 1, 5, 9, 6,
          0, 15, 2, 4, 3, 8, 5, 4, 1, 9, 2, 6, 15, 7, 0, 8, 6, 15, 5, 1, 3, 2,
          9, 0, 8, 4, 7, 15, 1, 6, 0, 5, 4, 2, 3, 9, 7, 8, 15, 2, 4, 6, 5, 8, 3,
          0, 7, 1, 5, 15, 2, 4, 3, 6, 1, 0, 6, 2, 5, 4, 3, 1, 15, 0, 2, 1, 3, 4,
          15, 0, 5, 15, 2, 5, 3, 4, 1, 0, 15, 3, 0, 15,
        ],
        freeBuy_r51: [
          8, 1, 15, 5, 0, 15, 4, 7, 15, 5, 6, 15, 4, 8, 10, 9, 15, 2, 7, 15, 1,
          3, 15, 0, 10, 2, 9, 15, 8, 3, 15, 1, 5, 15, 6, 0, 15, 7, 4, 15, 2, 1,
          7, 5, 3, 0, 6, 10, 9, 4, 8, 15, 3, 4, 0, 5, 6, 1, 7, 9, 10, 2, 8, 4,
          9, 10, 3, 15, 5, 6, 2, 7, 0, 1, 7, 3, 4, 2, 0, 6, 15, 8, 1, 5, 15, 2,
          3, 5, 0, 1, 4, 15, 3, 15, 2, 10, 15, 6, 9, 15,
        ],
        freeBuy_r52: [
          9, 15, 4, 1, 15, 5, 0, 8, 6, 15, 3, 10, 15, 4, 2, 15, 7, 9, 15, 5, 7,
          15, 0, 4, 15, 9, 1, 15, 3, 2, 10, 15, 8, 6, 15, 0, 1, 5, 4, 3, 15, 10,
          9, 8, 7, 2, 3, 9, 7, 10, 2, 0, 8, 6, 15, 5, 4, 1, 15, 4, 6, 0, 8, 9,
          3, 10, 7, 2, 5, 1, 4, 15, 7, 5, 3, 1, 2, 0, 6, 5, 15, 1, 2, 0, 6, 3,
          4, 15, 10, 5, 15, 7, 2, 15, 8, 3, 6, 1, 15, 0,
        ],
        freeBuy_r53: [
          6, 4, 15, 2, 10, 15, 9, 0, 15, 3, 5, 15, 6, 3, 15, 7, 1, 9, 15, 0, 4,
          15, 10, 8, 15, 2, 9, 15, 5, 8, 15, 2, 1, 15, 10, 0, 3, 4, 15, 6, 7, 2,
          10, 15, 5, 4, 7, 6, 0, 9, 3, 8, 1, 3, 9, 0, 5, 6, 7, 10, 8, 2, 1, 15,
          4, 7, 1, 2, 3, 10, 5, 0, 15, 9, 8, 6, 4, 5, 3, 2, 0, 15, 4, 7, 6, 1,
          2, 4, 15, 5, 0, 3, 15, 1, 1, 15, 7, 8, 5, 15,
        ],
      },
      paylines: {
        keno_lines_40: [
          [1, 4, 7, 10, 13],
          [0, 3, 6, 9, 12],
          [2, 5, 8, 11, 14],
          [0, 4, 8, 10, 12],
          [2, 4, 6, 10, 14],
          [0, 3, 7, 9, 12],
          [2, 5, 7, 11, 14],
          [1, 3, 6, 9, 13],
          [1, 5, 8, 11, 13],
          [0, 4, 7, 10, 12],
          [2, 4, 7, 10, 14],
          [0, 4, 6, 10, 12],
          [2, 4, 8, 10, 14],
          [1, 3, 7, 9, 13],
          [1, 5, 7, 11, 13],
          [1, 4, 6, 10, 13],
          [1, 4, 8, 10, 13],
          [0, 5, 6, 11, 12],
          [2, 3, 8, 9, 14],
          [1, 3, 8, 9, 13],
          [1, 5, 6, 11, 13],
          [0, 3, 8, 9, 12],
          [2, 5, 6, 11, 14],
          [0, 5, 8, 11, 12],
          [2, 3, 6, 9, 14],
          [0, 3, 7, 11, 14],
          [2, 5, 7, 9, 12],
          [0, 3, 7, 10, 13],
          [2, 5, 7, 10, 13],
          [0, 3, 6, 10, 13],
          [2, 5, 8, 10, 13],
          [0, 3, 6, 10, 14],
          [2, 5, 8, 10, 12],
          [0, 4, 8, 11, 14],
          [2, 4, 6, 9, 12],
          [1, 4, 6, 9, 12],
          [1, 4, 8, 11, 14],
          [2, 3, 7, 9, 14],
          [0, 5, 7, 11, 12],
          [1, 3, 7, 11, 13],
        ],
      },
      bonuses: {
        paid: {
          name: "paid",
          type: "@Reel",
          reelWindows: ["paid"],
          paylines: "keno_lines_40",
          extraBalanceInfo:
            '{"potLevel":[10,25,40,100],"colorfulReelStrip":[[1,2,3,1,2,3,1,2,3,1,2,3,1,2,3,1,2,3,1,2,3,1,2,3,1,2,3,1,2,3,1,2,3,1,2,3],[-1,-2,-3,-4,-1,-2,-3,-4,-1,-2,-3,-4,-1,-2,-3,-4,-1,-2,-3,-4,-1,-2,-3,-4,-1,-2,-3,-4,-1,-2,-3,-4,-1,-2,-3,-4,-1,-2,-3,-4]]}',
        },
        free: {
          name: "free",
          type: "@Reel",
          reelWindows: ["free"],
          paylines: "keno_lines_40",
          extraBalanceInfo:
            '{"potLevel":[10,25,40,100],"colorfulReelStrip":[[1,2,3,1,2,3,1,2,3,1,2,3,1,2,3,1,2,3,1,2,3,1,2,3,1,2,3,1,2,3,1,2,3,1,2,3],[-1,-2,-3,-4,-1,-2,-3,-4,-1,-2,-3,-4,-1,-2,-3,-4,-1,-2,-3,-4,-1,-2,-3,-4,-1,-2,-3,-4,-1,-2,-3,-4,-1,-2,-3,-4,-1,-2,-3,-4]]}',
        },
        freeBuy: {
          name: "freeBuy",
          type: "@Reel",
          reelWindows: ["freeBuy"],
          paylines: "keno_lines_40",
          extraBalanceInfo:
            '{"potLevel":[10,25,40,100],"colorfulReelStrip":[[1,2,3,1,2,3,1,2,3,1,2,3,1,2,3,1,2,3,1,2,3,1,2,3,1,2,3,1,2,3,1,2,3,1,2,3],[-1,-2,-3,-4,-1,-2,-3,-4,-1,-2,-3,-4,-1,-2,-3,-4,-1,-2,-3,-4,-1,-2,-3,-4,-1,-2,-3,-4,-1,-2,-3,-4,-1,-2,-3,-4,-1,-2,-3,-4]]}',
        },
      },
      reelWindows: {
        paid: {
          sizeReelWindow: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
          defaultReels: [
            "paid_r11",
            "paid_r12",
            "paid_r13",
            "paid_r21",
            "paid_r22",
            "paid_r23",
            "paid_r31",
            "paid_r32",
            "paid_r33",
            "paid_r41",
            "paid_r42",
            "paid_r43",
            "paid_r51",
            "paid_r52",
            "paid_r53",
          ],
          defaultSymbolMatrix: [
            [8],
            [9],
            [9],
            [5],
            [4],
            [3],
            [8],
            [14],
            [6],
            [8],
            [9],
            [7],
            [8],
            [9],
            [6],
          ],
        },
        free: {
          sizeReelWindow: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
          defaultReels: [
            "free_r11",
            "free_r12",
            "free_r13",
            "free_r21",
            "free_r22",
            "free_r23",
            "free_r31",
            "free_r32",
            "free_r33",
            "free_r41",
            "free_r42",
            "free_r43",
            "free_r51",
            "free_r52",
            "free_r53",
          ],
          defaultSymbolMatrix: [
            [8],
            [9],
            [6],
            [5],
            [4],
            [3],
            [8],
            [14],
            [6],
            [8],
            [9],
            [6],
            [8],
            [9],
            [6],
          ],
        },
        freeBuy: {
          sizeReelWindow: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
          defaultReels: [
            "freeBuy_r11",
            "freeBuy_r12",
            "freeBuy_r13",
            "freeBuy_r21",
            "freeBuy_r22",
            "freeBuy_r23",
            "freeBuy_r31",
            "freeBuy_r32",
            "freeBuy_r33",
            "freeBuy_r41",
            "freeBuy_r42",
            "freeBuy_r43",
            "freeBuy_r51",
            "freeBuy_r52",
            "freeBuy_r53",
          ],
          defaultSymbolMatrix: [
            [8],
            [9],
            [6],
            [5],
            [3],
            [4],
            [8],
            [14],
            [6],
            [8],
            [9],
            [6],
            [8],
            [9],
            [6],
          ],
        },
      },
      payTableInfo: {
        RuleBasicPay: [
          {
            id: 0,
            match: 5,
            amount: 10,
          },
          {
            id: 0,
            match: 4,
            amount: 5,
          },
          {
            id: 0,
            match: 3,
            amount: 3,
          },
          {
            id: 1,
            match: 5,
            amount: 10,
          },
          {
            id: 1,
            match: 4,
            amount: 5,
          },
          {
            id: 1,
            match: 3,
            amount: 3,
          },
          {
            id: 2,
            match: 5,
            amount: 10,
          },
          {
            id: 2,
            match: 4,
            amount: 5,
          },
          {
            id: 2,
            match: 3,
            amount: 3,
          },
          {
            id: 3,
            match: 5,
            amount: 10,
          },
          {
            id: 3,
            match: 4,
            amount: 5,
          },
          {
            id: 3,
            match: 3,
            amount: 3,
          },
          {
            id: 4,
            match: 5,
            amount: 15,
          },
          {
            id: 4,
            match: 4,
            amount: 8,
          },
          {
            id: 4,
            match: 3,
            amount: 3,
          },
          {
            id: 5,
            match: 5,
            amount: 15,
          },
          {
            id: 5,
            match: 4,
            amount: 8,
          },
          {
            id: 5,
            match: 3,
            amount: 3,
          },
          {
            id: 6,
            match: 5,
            amount: 20,
          },
          {
            id: 6,
            match: 4,
            amount: 10,
          },
          {
            id: 6,
            match: 3,
            amount: 5,
          },
          {
            id: 7,
            match: 5,
            amount: 20,
          },
          {
            id: 7,
            match: 4,
            amount: 10,
          },
          {
            id: 7,
            match: 3,
            amount: 5,
          },
          {
            id: 8,
            match: 5,
            amount: 50,
          },
          {
            id: 8,
            match: 4,
            amount: 25,
          },
          {
            id: 8,
            match: 3,
            amount: 10,
          },
          {
            id: 9,
            match: 5,
            amount: 150,
          },
          {
            id: 9,
            match: 4,
            amount: 50,
          },
          {
            id: 9,
            match: 3,
            amount: 20,
          },
        ],
      },
      buyFeatureInfo: {
        configs: [
          {
            buyFeatureId: 1,
            pricePercent: 10000,
          },
        ],
      },
    },
    prevSymbolMatrix: [
      [8],
      [9],
      [9],
      [5],
      [4],
      [3],
      [8],
      [14],
      [6],
      [8],
      [9],
      [7],
      [8],
      [9],
      [6],
    ],
    bOnGameCycle: false,
    extraPlayData: '{"pots":{"paid":[0,0,0]}}',
    countryCode: "US",
    language: "en",
    currencyCode: "DMO",
    denominations: [0.01, 0.05, 0.1, 0.2, 0.5, 1, 2, 5, 10, 20, 50, 100],
    featureOnOff: {
      buyFeature: true,
      fastSpin: true,
      autoSpin: true,
      autoInfinitySpin: true,
      clock: true,
      bestReplay: true,
      history: true,
    },
    gameProperties: {
      DELAY_FEATURE_START_SINGLE: 120000,
      DELAY_FEATURE_START_MULTI: -1,
      DELAY_FEATURE_END: 7000,
      betLimitAmount: 999999999,
      denominations: [0.01, 0.05, 0.1, 0.2, 0.5, 1, 2, 5, 10, 20, 50, 100],
      betMultipliers: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      defaultDenomination: 0.01,
      delayFeatureStartSingle: 120000,
      delayFeatureStartMulti: -1,
      delayFeatureEnd: 7000,
      rtp: 95.96,
      buyFeatureRtp: 95.93,
    },
    networkTimeout: 30,
    rtp: 95.96,
    buyFeatureRtp: 95.93,
    gameVersion: "v1.0.0",
    requestId: "",
    errorCode: 0,
  },
};
